import RichText from './rich-text';

export * from './rich-text';
export default RichText;
